import request from '@/config/axios';

/**
 * BasicDocGetBlockTree
 * 获取企业基本信息
 * @return
 */
export function userSettingGetCompanyInfo(data) {
    return request({
        url: '/company/getCompanyInfo',
        method: 'GET',
        params: data
    });
}

/**
 * BasicDocGetBlockTree
 * 邮箱验证保存
 * @return
 */
export function userSettingLoginActivateVerificationCodeByEmail(data) {
    return request({
        url: '/company/loginActivateVerificationCodeByEmail',
        method: 'POST',
        data
    });
}

/**
 * BasicDocGetBlockTree
 * 手机验证保存
 * @return
 */
export function userSettingLoginActivateVerificationCodeByPhone(data) {
    return request({
        url: '/company/loginActivateVerificationCodeByPhone',
        method: 'POST',
        data
    });
}

/**
 * BasicDocGetBlockTree
 * 修改密码保存
 * @return
 */
export function userSettingUpdatePassWord(data) {
    return request({
        url: '/company/updatePassWord',
        method: 'POST',
        data
    });
}


/**
 * BasicDocGetBlockTree
 * 发送手机验证码
 * @return
 */
export function userSettingLoginSendVerificationCodeByPhone(data) {
    return request({
        url: '/company/loginSendVerificationCodeByPhone',
        method: 'POST',
        data
    });
}

/**
 * BasicDocGetBlockTree
 * 发送邮箱验证码
 * @return
 */
export function userSettingLoginSendVerificationCodeByEmail(data) {
    return request({
        url: '/company/loginSendVerificationCodeByEmail',
        method: 'POST',
        data
    });
}